module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-17-2598a255f6ed2f028efdb313f8941e14.jpg";